// =============================================================================
// LocalStorage Adapter
// Low-level storage operations with error handling
// =============================================================================

const STORAGE_KEY = 'indxone.workspace.v1';

/**
 * Load raw data from localStorage
 * Returns null if key doesn't exist or parsing fails
 */
export function loadRawFromLocalStorage<T>(): T | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch (error) {
    console.error('[Storage] Failed to load from localStorage:', error);
    return null;
  }
}

/**
 * Save raw data to localStorage
 * Handles serialization errors
 */
export function saveRawToLocalStorage<T>(data: T): boolean {
  try {
    const raw = JSON.stringify(data);
    localStorage.setItem(STORAGE_KEY, raw);
    return true;
  } catch (error) {
    console.error('[Storage] Failed to save to localStorage:', error);
    return false;
  }
}

/**
 * Remove the workspace key from localStorage
 */
export function clearLocalStorage(): boolean {
  try {
    localStorage.removeItem(STORAGE_KEY);
    return true;
  } catch (error) {
    console.error('[Storage] Failed to clear localStorage:', error);
    return false;
  }
}

/**
 * Check if workspace exists in localStorage
 */
export function workspaceExists(): boolean {
  return localStorage.getItem(STORAGE_KEY) !== null;
}
